import { isEmpty } from '@dxb-web-ui-framework/common/utils/Helper';
import { PasswordPolicy, PasswordPolicyResponseDTO } from '../entities';
import { PasswordRuleTypes } from '../types';

const PasswordRuleTypesArr = Object.keys(PasswordRuleTypes);

const passwordPolicyDTOToPasswordPolicyAdapter = (data: PasswordPolicyResponseDTO): PasswordPolicy[] => {
  if (!data.body) {
    throw new Error('Error');
  }

  const { rules } = data.body;

  if (isEmpty(rules)) {
    return [];
  }

  return PasswordRuleTypesArr.reduce((acc: PasswordPolicy[], passwordRule: string) => {
    const foundRule = rules.find(rule => rule.ruleType === passwordRule);
    if (foundRule) {
      acc.push(new PasswordPolicy(foundRule.ruleType, foundRule.value));
    }
    if (passwordRule === 'NOT_SAME_PASSWORD') {
      acc.push(new PasswordPolicy(passwordRule as PasswordRuleTypes));
    }
    return acc;
  }, []);
};

export { passwordPolicyDTOToPasswordPolicyAdapter };
